var chunkToChildrenMap = {
	"52": [
		8291,
		4533,
		5357,
		1860,
		1545
	],
	"2139": [
		5244,
		4751,
		4533,
		7986,
		6693,
		1650,
		1860,
		9426,
		2475,
		4886
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));